import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconCloseOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M12.021 10.978 22.228.771l1.021 1.021L13.042 12l10.189 10.188-1.023 1.023-10.189-10.188L1.772 23.269.75 22.25 10.999 12 .769 1.77 1.792.75z" /></svg>
);
